import { render } from "./screen.vue?vue&type=template&id=a4819a52&scoped=true"
import script from "./screen.vue?vue&type=script&lang=js"
export * from "./screen.vue?vue&type=script&lang=js"

import "./screen.vue?vue&type=style&index=0&id=a4819a52&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4819a52"]])

export default __exports__